/**
 * Converts numeric amount to Indian Currency Words (Lakhs / Crores)
 * e.g. 12895 -> "Twelve Thousand Eight Hundred Ninety-Five Rupees Only"
 */

const ONES = [
  "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen"
];

const TENS = [
  "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
];

function convertLessThanThousand(num) {
  let str = "";
  if (num >= 100) {
    str += ONES[Math.floor(num / 100)] + " Hundred ";
    num %= 100;
  }
  if (num >= 20) {
    str += TENS[Math.floor(num / 10)] + (num % 10 !== 0 ? "-" + ONES[num % 10] : "");
  } else if (num > 0) {
    str += ONES[num];
  }
  return str.trim();
}

export function numberToIndianWords(amount) {
  const num = Math.round(Number(amount || 0));
  if (num === 0) return "Zero Rupees Only";
  if (num < 0) return "Minus " + numberToIndianWords(Math.abs(num));

  let crores = Math.floor(num / 10000000);
  let remainder = num % 10000000;

  let lakhs = Math.floor(remainder / 100000);
  remainder %= 100000;

  let thousands = Math.floor(remainder / 1000);
  remainder %= 1000;

  let hundreds = remainder;

  let words = "";

  if (crores > 0) {
    words += convertLessThanThousand(crores) + " Crore ";
  }
  if (lakhs > 0) {
    words += convertLessThanThousand(lakhs) + " Lakh ";
  }
  if (thousands > 0) {
    words += convertLessThanThousand(thousands) + " Thousand ";
  }
  if (hundreds > 0) {
    words += convertLessThanThousand(hundreds);
  }

  return words.trim() + " Rupees Only";
}

export default numberToIndianWords;
